// Elementos HTML
const loader = document.querySelector<HTMLDivElement>('#loader')!;

/**
 *
 * @param options
 * @returns
 */
export function loadLoader({ start = true, topScroll = 0 }: OptionsLoader) {
  if (start) {
    loader.classList.toggle('d-none');
    document.body.style.overflow = 'hidden';
    window.scrollTo({
      top: topScroll
    });
    return;
  }

  loader.classList.toggle('d-none');
  document.body.style.overflow = '';
}

// Definición de Tipos e Interfaces
type OptionsLoader = {
  start?: boolean;
  topScroll?: number;
};
